import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgManageElementsBlack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.62533 15.6389L1.66699 12.6806L2.6392 11.7084L4.61839 13.6737L8.28506 10.007L9.25726 11.0001L4.62533 15.6389ZM4.62533 8.97227L1.66699 6.01394L2.6392 5.04173L4.61839 7.00702L8.28506 3.34033L9.25726 4.33339L4.62533 8.97227ZM10.8337 14.0278V12.639H18.3337V14.0278H10.8337ZM10.8337 7.36117V5.97229H18.3337V7.36117H10.8337Z",
		fill: "#393A36"
	})
});
export default SvgManageElementsBlack;
